// extracted by mini-css-extract-plugin
export default {"tutorial":"Button_tutorial__gnY3L","btn":"Button_btn__LGHJQ"};